// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const PicturesMobile = () => {
  const data = useStaticQuery(graphql`
    query PicturesMobileQuery {
      img1: file(relativePath: { eq: "img1.png" }) {
        childImageSharp {
          fixed(width: 188, height: 188) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      img2: file(relativePath: { eq: "founders.png" }) {
        childImageSharp {
          fixed(width: 212, height: 212) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <div
      sx={{
        display: `flex`,
        flexDirection: `column`,
        height: `15rem`,
        overflow: `hidden`,
        marginBottom: `-2rem`,
      }}
    >
      <Img
        alt=""
        sx={{ position: `relative`, top: `40% `, left: `0%` }}
        fixed={data.img1.childImageSharp.fixed}
      />
      <Img
        alt="founders"
        sx={{ position: `relative`, top: `-47% `, right: `-45%` }}
        fixed={data.img2.childImageSharp.fixed}
      />
    </div>
  )
}

export default PicturesMobile
